<template>
  <div class="footer">
    <div class="footer_main">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'commonFooter',
  props: {
  },
  methods: {

  }
}
</script>

<style scoped lang="less">
.footer {
  position: fixed;
  bottom:0;left:0;right:0;
  // box-shadow:0px -1px 14px 0px rgba(0,0,0,0.09);
  z-index:333;
  background:#fff;
  height:108px;
  width:100%;
  .footer_main{
    margin:0 28px;
    height:108px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
}
</style>
